import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateToastSendGlobal } from './use-update-toast-send-global'

export const ToastSendGlobal = memo(() => {
  useUpdateToastSendGlobal()

  const { currentNotifyGiftListToast } = useGlobalStore(
    useShallow((state) => ({
      currentNotifyGiftListToast: state.currentNotifyGiftListToast,
    })),
  )

  return (
    <div className="w-screen h-screen flex items-center flex-col gap-2">
      {currentNotifyGiftListToast && (
        <Toast
          key={currentNotifyGiftListToast.id}
          item={currentNotifyGiftListToast}
        />
      )}
    </div>
  )
})
